import { makeStyles, fade } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: fade(theme.colors.danger, 0.15),
    padding: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    '@media print': {
      display: 'none',
    },
  },
  containerNone: {
    backgroundColor: fade(theme.colors.white, 0.15),
  },
  innerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 42,
    marginRight: theme.spacing(1),
  },
  addButton: {
    marginLeft: theme.spacing(1),
  },
  formControlOverride: {
    marginRight: 0,
    marginLeft: 0,
  },
  checkbox: {
    marginLeft: -7,
    color: theme.palette.text.primary,
  },
  disabled: {
    color: fade(theme.colors.grey, 0.5),
  },
}));

export default useStyles;
